import { MemoryPackWriter } from "./MemoryPackWriter.js";
import { MemoryPackReader } from "./MemoryPackReader.js";

export class ModelParameterDto {
    modelParameterId: string;
    name: string | null;
    value: string | null;

    constructor() {
        this.modelParameterId = "00000000-0000-0000-0000-000000000000";
        this.name = null;
        this.value = null;

    }

    static serialize(value: ModelParameterDto | null): Uint8Array {
        const writer = MemoryPackWriter.getSharedInstance();
        this.serializeCore(writer, value);
        return writer.toArray();
    }

    static serializeCore(writer: MemoryPackWriter, value: ModelParameterDto | null): void {
        if (value == null) {
            writer.writeNullObjectHeader();
            return;
        }

        writer.writeObjectHeader(3);
        writer.writeGuid(value.modelParameterId);
        writer.writeString(value.name);
        writer.writeString(value.value);

    }

    static serializeArray(value: (ModelParameterDto | null)[] | null): Uint8Array {
        const writer = MemoryPackWriter.getSharedInstance();
        this.serializeArrayCore(writer, value);
        return writer.toArray();
    }

    static serializeArrayCore(writer: MemoryPackWriter, value: (ModelParameterDto | null)[] | null): void {
        writer.writeArray(value, (writer, x) => ModelParameterDto.serializeCore(writer, x));
    }

    static deserialize(buffer: ArrayBuffer): ModelParameterDto | null {
        return this.deserializeCore(new MemoryPackReader(buffer));
    }

    static deserializeCore(reader: MemoryPackReader): ModelParameterDto | null {
        const [ok, count] = reader.tryReadObjectHeader();
        if (!ok) {
            return null;
        }

        const value = new ModelParameterDto();
        if (count == 3) {
            value.modelParameterId = reader.readGuid();
            value.name = reader.readString();
            value.value = reader.readString();

        }
        else if (count > 3) {
            throw new Error("Current object's property count is larger than type schema, can't deserialize about versioning.");
        }
        else {
            if (count == 0) return value;
            value.modelParameterId = reader.readGuid(); if (count == 1) return value;
            value.name = reader.readString(); if (count == 2) return value;
            value.value = reader.readString(); if (count == 3) return value;

        }
        return value;
    }

    static deserializeArray(buffer: ArrayBuffer): (ModelParameterDto | null)[] | null {
        return this.deserializeArrayCore(new MemoryPackReader(buffer));
    }

    static deserializeArrayCore(reader: MemoryPackReader): (ModelParameterDto | null)[] | null {
        return reader.readArray(reader => ModelParameterDto.deserializeCore(reader));
    }
}
